// var webkit = (webkit !== undefined && webkit !== null) ? webkit : null
// var Android = (Android !== undefined && Android !== null) ? Android : null
var webkit = null
var Android = null

const state = {
  net: false,
  device: {
    brand: null,
    model: null
  },
  updateFile:{
    color: "success",
    show:false,
    msj: "File Uploaded Successfully"
  }
}
const mutations = {
  net (state, net) {
    state.net = net
  },
  currentInvoice (state, currentInvoice) {
    state.currentInvoice = currentInvoice
  },
  showUploadFile(state,show) {
    state.updateFile.show = show;
  }

}
const actions = {
  net ({commit}, net) {
    if (net === null || net === undefined) {
      net = false
    }
    commit('net', net)
  },
  showUploadFile ({commit}, show){
    commit('showUploadFile', show)
  },
  openBarCodeReader ({state}) {
    if (webkit !== null || Android !== null) {
      if (state.device.brand === 'ios') {
        webkit.messageHandlers.IOS.postMessage('{"action": "openBarCodeReader"}')
      } else {
        Android.openBarCodeReader()
      }
    } else {
      console.log('openBarCodeReader')
    }
  },
  openUrl ({state}, url) {
    if (webkit !== null || Android !== null) {
      if (state.device.brand === 'ios') {
        webkit.messageHandlers.IOS.postMessage('{"action": "openUrl", "url" : "' + url + '"}')
      } else {
        Android.openUrl(url)
      }
    } else {
      console.log('openUrl')
    }
  },
  getSessionId ({state}) {
    if (webkit !== null || Android !== null) {
      if (state.device.brand === 'ios') {
        webkit.messageHandlers.IOS.postMessage('{"action": "getSessionId"}')
      } else {
        Android.getSessionId()
      }
    } else {
      console.log('getSessionId')
    }
  },
  setSessionId ({state}, sessionId) {
    if (webkit !== null || Android !== null) {
      if (state.device.brand === 'ios') {
        webkit.messageHandlers.IOS.postMessage('{"action": "setSessionId", "sessionId": "' + sessionId + '"}')
      } else {
        Android.setSessionId(sessionId)
      }
    } else {
      console.log('setSessionId')
    }
  },
  getDeviceInfo ({state}) {
    if (webkit !== null || Android !== null) {
      if (state.device.brand === 'ios') {
        webkit.messageHandlers.IOS.postMessage('{"action": "getDeviceInfo"}')
      } else {
        Android.getDeviceInfo()
      }
    } else {
      console.log('getDeviceInfo')
    }
  },
  signOut ({state}) {
    if (webkit !== null || Android !== null) {
      if (state.device.brand === 'ios') {
        webkit.messageHandlers.IOS.postMessage('{"action": "signOut"}')
      } else {
        Android.signOut()
      }
    } else {
      console.log('signOut')
    }
  },
  closeApp ({state}) {
    if (webkit !== null || Android !== null) {
      if (state.device.brand === 'ios') {
        webkit.messageHandlers.IOS.postMessage('{"action": "closeApp"}')
      } else {
        Android.closeApp()
      }
    } else {
      console.log('closeApp')
    }
  },
  uploadInvoice ({state}, url, gia, packid, clientId) {
    if (webkit !== null || Android !== null) {
      if (state.device.brand === 'ios') {
        webkit.messageHandlers.IOS.postMessage('{"action": "uploadInvoice", "photoUrl": "' + url + '", "guiaNo": "' + gia + '", "trackingNo": "' + packid + '", "clientId": "' + clientId + '"}')
      } else {
        Android.uploadInvoice(url, gia, packid, clientId)
      }
    } else {
      console.log('uploadInvoice')
    }
  },
  openLocationInMap ({state}, log, lat, title) {
    if (webkit !== null || Android !== null) {
      if (state.device.brand === 'ios') {
        webkit.messageHandlers.IOS.postMessage('{"action": "openLocationInMap", "longitud": "' + log + '", "latitud": "' + lat + '", "officeLabel": "' + title + '"}')
      } else {
        Android.openLocationInMap(log, lat, title)
      }
    } else {
      console.log('openLocationInMap')
    }
  }
}
const getters = {
  updateFile: state => {
    return state.updateFile
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
